module.exports = __webpack_public_path__ + "img/bakery_demo.3be2e36e.jpg";